import * as React from 'react';
import { Link } from 'react-router';
import { CartIcon } from 'components/Icons/Icons';
import StringWidget from 'components/StringWidget/StringWidget';
import DropDown, { DropDownPosition } from 'components/DropDownMenu/DropDownMenu';
import SimpleImage from 'components/Common/Image/SimpleImage';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import getImageUrl from 'utils/getImageUrl';
import get from 'lodash/get';
import shallowEqual from 'utils/shallowEqual';
import defaultStyles from './CartIcon.css';
const DROPDOWN_MAX_WIDTH = 250;
class CartNotificationIcon extends React.Component {
    constructor(props) {
        super(props);
        this.getCartItemsLength = (props) => {
            const cartItems = get(props.userState, ['cart', 'items']) || [];
            return cartItems.length;
        };
        const cartCount = this.getCartItemsLength(props);
        this.state = {
            cartCount
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const cartCount = this.getCartItemsLength(nextProps);
        this.setState({
            cartCount
        });
    }
    shouldComponentUpdate(nextProps, nextState) {
        return !shallowEqual(this.props, nextProps) || this.state.cartCount !== nextState.cartCount;
    }
    render() {
        const { cartCount } = this.state;
        const { coBrandStyles } = this.props;
        const styles = Object.assign({}, defaultStyles, coBrandStyles);
        const latestBasketBuildingItem = get(this.props, [
            'userState',
            'cart',
            'latestBasketBuildingItem'
        ]);
        const content = (<Link to="/viewcart?otracker=Cart_Icon_Click" className={styles['cart']} data-aid="viewcart">
				<CartIcon width={14} height={14} className={styles['cart-icon']} pathClassName={styles['cart-fill']}/>
				{cartCount > 0 && <div className={styles['count']}>{cartCount}</div>}
				<StringWidget strKey="cart"/>
			</Link>);
        return (<DropDown position={DropDownPosition.LEFT} fixPosition contentMaxWidth={DROPDOWN_MAX_WIDTH} content={content} contentClassName={styles['content-container']} tooltipClassName={styles['cart-tooltip-container']} containerClassName={styles['cart-tooltip']} active={!!latestBasketBuildingItem}>
				{latestBasketBuildingItem && (<React.Fragment>
						<SimpleImage src={getImageUrl(latestBasketBuildingItem.imageUrl, '200')} size={80}/>
						<div className={styles['content']}>
							<div className={styles['header']}>{stringTemplate('itemAddedInCart')}</div>
							<Link to="/viewcart?otracker=View_Cart_Click" className={styles['go-to-cart-btn']}>
								{stringTemplate('viewCart')}
							</Link>
						</div>
					</React.Fragment>)}
			</DropDown>);
    }
}
export default CartNotificationIcon;
